<ng-container *transloco="let t">
    @if (flyoutKey && $any(t(flyoutKey)); as items) { @if (items[0]?.header) {
    <mat-card
        appearance="outlined"
        class="sub-title-tooltip"
        [ngClass]="{
            display: active,
            'flip-up': flipUp
        }"
    >
        <mat-card-content>
            @for (item of items; track item) {
            <h3>{{ item.header }}</h3>
            <p>{{ item.text }}</p>
            }
        </mat-card-content>
    </mat-card>
    } }
</ng-container>
